import { types } from "./actionTypes";
export const ShipmentMasterList = (filters, searchFilter,callback) => ({
  type: types.SHIPMENT_MASTER,
  filters,
  searchFilter,
  callback,
});
